import { render } from "./CustSelect.vue?vue&type=template&id=66fd600f&ts=true"
import script from "./CustSelect.vue?vue&type=script&lang=ts"
export * from "./CustSelect.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__